var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import withDesign from '../../../hocs/withDesign';
import useWatch from '../../../hooks/useWatch';
import { BaseInput } from '../../atoms/BaseInput';
import { CheckboxInput as BaseCheckboxInput } from '../../atoms/CheckboxInput';
import { RadioInput } from '../../atoms/RadioInput';
import { RangeInput as BaseRangeInput } from '../../atoms/RangeInput';
export function useFormInputProps(_a, innerRef) {
    var name = _a.name, type = _a.type, required = _a.required, disabled = _a.disabled, onChange = _a.onChange, onBlur = _a.onBlur, value = _a.value, id = _a.id, 
    // props exclusive of react-hook-form register
    maxLength = _a.maxLength, minLength = _a.minLength, max = _a.max, min = _a.min, pattern = _a.pattern, validate = _a.validate, _b = _a.valueAsDate, valueAsDate = _b === void 0 ? type === 'date' : _b, _c = _a.valueAsNumber, valueAsNumber = _c === void 0 ? type === 'number' : _c, setValueAs = _a.setValueAs, shouldUnregister = _a.shouldUnregister, deps = _a.deps, props = __rest(_a, ["name", "type", "required", "disabled", "onChange", "onBlur", "value", "id", "maxLength", "minLength", "max", "min", "pattern", "validate", "valueAsDate", "valueAsNumber", "setValueAs", "shouldUnregister", "deps"]);
    if (!name) {
        throw new Error("Missing prop name on FormInput: ".concat(props.design));
    }
    var _d = useFormContext(), register = _d.register, control = _d.control;
    var _e = register(name, {
        required: required,
        disabled: disabled,
        onChange: onChange,
        onBlur: onBlur,
        value: value,
        maxLength: maxLength,
        minLength: minLength,
        max: max,
        min: min,
        pattern: pattern,
        validate: validate,
        valueAsDate: valueAsDate,
        valueAsNumber: valueAsNumber,
        setValueAs: setValueAs,
        shouldUnregister: shouldUnregister,
        deps: deps,
    }), ref = _e.ref, formProps = __rest(_e, ["ref"]);
    var componentProps = __assign(__assign({ type: type, id: id !== null && id !== void 0 ? id : name, ref: function (e) {
            ref(e);
            if (innerRef) {
                innerRef.current = e;
            }
        }, min: min, max: max, value: value, control: control }, props), formProps);
    return componentProps;
}
export var FormInputComponent = forwardRef(function (props, innerRef) {
    var _a = useFormInputProps(props, innerRef), min = _a.min, max = _a.max, value = _a.value, decimalScale = _a.decimalScale, control = _a.control, componentProps = __rest(_a, ["min", "max", "value", "decimalScale", "control"]);
    var setValue = useFormContext().setValue;
    if (props.type === 'radio') {
        return _jsx(RadioInput, __assign({ value: value }, componentProps));
    }
    if (props.type === 'checkbox') {
        return _jsx(CheckboxInput, __assign({}, componentProps));
    }
    if (props.type === 'range') {
        return _jsx(RangeInput, __assign({ min: min, max: max }, componentProps));
    }
    if (decimalScale) {
        return (_jsx(Controller, { control: control, name: componentProps.name, render: function (_a) {
                var _b = _a.field, name = _b.name, value = _b.value;
                return (_jsx(NumericFormat, __assign({ name: name, value: value, onValueChange: function (e) { return setValue(name, e.formattedValue); }, decimalScale: decimalScale, customInput: BaseInput }, componentProps)));
            } }));
    }
    return _jsx(BaseInput, __assign({}, componentProps));
});
export var CheckboxInput = forwardRef(function (props, ref) {
    var name = props.name;
    var control = useFormContext().control;
    var values = useWatch({ control: control, name: name });
    var checked = values[name];
    return _jsx(BaseCheckboxInput, __assign({ ref: ref, checked: checked }, props));
});
export var RangeInput = forwardRef(function (props, ref) {
    var name = props.name, min = props.min, max = props.max;
    var control = useFormContext().control;
    var values = useWatch({ control: control, name: name });
    var value = values[name];
    var _a = min.value, minValue = _a === void 0 ? min : _a;
    var _b = max.value, maxValue = _b === void 0 ? max : _b;
    return _jsx(BaseRangeInput, __assign({ min: minValue, max: maxValue, ref: ref, value: value }, props));
});
export var FormInput = withDesign(FormInputComponent);
FormInput.displayName = 'FormInput';
